import React from 'react';
import WidgetCreator from '..';
import { createMapWidgetRelativeUrl } from '../../../shared/url-utils';
import { MapUpdateMessage, WindowMessageType } from '../../../shared/windowMessages';
import { NetworkId } from '../../../types';

interface MapCreatorProps {
  networkId: NetworkId;
}

export const MapCreator: React.FC<MapCreatorProps> = ({ networkId }) => {
  const [iframeSrc, setIframeSrc] = React.useState(createMapWidgetRelativeUrl(networkId, {}));

  // Listen for messages from the embedded map widget and
  // update the iframe src url.
  React.useEffect(() => {
    const listener = (event: MessageEvent) => {
      if (event.origin !== window.location.origin || event.data?.type !== WindowMessageType.MapUpdate) {
        return;
      }
      const msg: MapUpdateMessage = event.data;

      setIframeSrc(
        createMapWidgetRelativeUrl(networkId, {
          datasourceId: msg.datasourceId ?? undefined,
          latitude: msg.viewport?.latitude ?? undefined,
          longitude: msg.viewport?.longitude,
          zoom: msg.viewport?.zoom,
          searchedLatitude: msg.searchedLocation?.coordinates[1],
          searchedLongitude: msg.searchedLocation?.coordinates[0],
        })
      );
    };
    window.addEventListener('message', listener);

    return () => {
      window.removeEventListener('message', listener);
    };
  }, []);

  return (
    <WidgetCreator
      iframeSrc={iframeSrc}
      iframeTitle="Map Widget"
      initialWidth={600}
      initialHeight={600}
      updateIframeWhenSrcChanges={false}
    />
  );
};
